import React from 'react';
import '../styles.css'; // Ensure styles are properly linked

const About = () => {
  return (
    <div className="container mt-5">
      <h1 className="text-warning text-center">About Sirius Music Group</h1>
      <p className="text-center lead">
        Sirius Music Group is a leading global music production company, shaping the future of sound.
      </p>

      <div className="row mt-4">
        <div className="col-md-6">
          <h2 className="text-warning">🌎 Our Mission</h2>
          <p>
            At Sirius Music, we believe in empowering artists to create, innovate, and inspire through music. 
            Our goal is to revolutionize the industry with cutting-edge sound production and artist collaboration.
          </p>
        </div>
        <div className="col-md-6">
          <img 
            src="https://visionkraft-bucket.s3.us-east-1.amazonaws.com/sirius-music/logo/logo.png" 
            alt="Sirius Music Group" 
            className="about-image"
          />
        </div>
      </div>

      <div className="mt-5">
        <h2 className="text-warning">🎶 What We Offer</h2>
        <ul className="list-group">
          <li className="list-group-item">✔ High-quality music production and sound engineering</li>
          <li className="list-group-item">✔ Artist development and management</li>
          <li className="list-group-item">✔ Global music distribution and streaming</li>
          <li className="list-group-item">✔ Live events, concerts, and music festivals</li>
        </ul>
      </div>

      <div className="mt-5">
        <h2 className="text-warning">🌟 Why Choose Sirius Music?</h2>
        <p>
          With a talented roster of musicians, world-class studios, and a passion for innovation, 
          we are redefining what it means to be a modern music label.
        </p>
      </div>

      <div className="text-center mt-4">
        <h2 className="text-warning">📍 Contact Us</h2>
        <p>📧 Email: <a href="mailto:info@siriusmusicgroup.com">info@siriusmusic.com</a></p>
        <p>📍 Location: Seattle, Washington | Nairobi, Kenya</p>
      </div>
    </div>
  );
};

export default About;